import css from "styled-jsx/css";

export const componentStyles = css.global`
  .cluster-selection-item-component {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 16px;
    left: 0;
    display: flex;
    align-items: center;
    border: 3px solid;
    border-radius: 8px;
    cursor: pointer;
    padding: 0px 24px;
    background-color: white;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.14);
    transition: transform 200ms ease;

    &:hover {
      transform: scale(1.025);
    }

    .cluster-selection-item-image {
      width: 30px;
      margin-right: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .title {
      flex-grow: 1;
    }
  }
`;
